var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"signDialog"},[_c('sign-in-form',{ref:"signInForm"}),_c('sign-in-table',{ref:"signInTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }